import React from 'react';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmStyle?: 'danger' | 'primary';
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  confirmStyle = 'primary',
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;
  return (
    <div
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:20 }}
      onClick={onCancel || onConfirm}
    >
      <div
        style={{ background:'var(--bg2)', border:'1px solid var(--border2)', borderRadius:10, width:'100%', maxWidth:400, overflow:'hidden', boxShadow:'0 20px 60px rgba(0,0,0,.5)' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div style={{ fontSize:15, fontWeight:600, color:'var(--text)' }}>{title}</div>
          <button onClick={onCancel || onConfirm} style={{ background:'transparent', border:'none', color:'var(--muted)', cursor:'pointer', fontSize:18, lineHeight:1 }}>✕</button>
        </div>
        <div style={{ padding:'20px' }}>
          <p style={{ fontSize:13, color:'var(--muted)', lineHeight:1.7, whiteSpace: 'pre-wrap' }}>{message}</p>
        </div>
        <div style={{ padding:'14px 20px', borderTop:'1px solid var(--border)', display:'flex', justifyContent:'flex-end', gap:8 }}>
          {onCancel && cancelLabel && (
            <button
              onClick={onCancel}
              style={{ padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500, cursor:'pointer', background:'transparent', border:'1px solid var(--border)', color:'var(--muted)' }}
            >
              {cancelLabel}
            </button>
          )}
          <button
            onClick={onConfirm}
            style={{
              padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500,
              cursor:'pointer', border:'none', color:'#fff',
              background: confirmStyle === 'danger' ? 'var(--red)' : 'var(--blue)',
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
